import { render, staticRenderFns } from "./RecommendSquare.vue?vue&type=template&id=b201bb20&scoped=true&"
import script from "./RecommendSquare.vue?vue&type=script&lang=js&"
export * from "./RecommendSquare.vue?vue&type=script&lang=js&"
import style0 from "./RecommendSquare.vue?vue&type=style&index=0&id=b201bb20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b201bb20",
  null
  
)

export default component.exports